export enum UserStatus {
  BUFFER = 'buffer',
  UNVERIFIED = 'unverified',
  VERIFIED_AUTH_FIELD = 'verified-auth-field',
  VERIFIED_FIELD_DATA = 'verified-field-data',
  VERIFIED_FULL = 'verified-full',
}
